import classNames from 'classnames';
import {map} from 'lodash';
import moment from 'moment';
import numeral from 'numeral';
import {PropTypes} from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';
import earthFlag from '../../../../../assets/img/other/flag-earth.svg';
import SingleDatePickerWrapper from '../../../../../components/DatePicker/SingleDatePickerWrapper';
import {getEndpoint, getHeaders} from '../../../../../helpers/endpoint';
import {leagueMode} from '../../../../../pages/Support/League/Widgets/LeagueInfo/components/Infos';

const month = moment().month();
const year = moment().year();

const fetchStatsLeaguesModes = (
  endDate,
  onSuccess = () => {},
  onError = () => {},
) => {
  return (_dispatch, getState) => {
    fetch(getEndpoint('fetchStatsLeaguesModes', endDate), {
      method: 'GET',
      headers: getHeaders(getState().authentication),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error) {
          onError(data.error);
        } else {
          onSuccess(data);
        }
      })
      .catch(error => {
        onError(error);
      });
  };
};

// Si on est en août ou plus la saison est l'année en cours.
// Année en cours = 2018
// Si mois < août Alors saison = 2017 Sinon saison = 2018
const currentSeason = month >= 7 ? year : year - 1;

class DivisionsByMode extends React.Component {
  constructor(props) {
    super(props);
    // We set the date to yesterday and we subtract 30 days
    const today = new Date();
    const end = moment(today.setDate(today.getDate())).format('YYYY-MM-DD');

    this.state = {end, lang: 'ALL'};
  }

  fetchStats() {
    const {end} = this.state;

    this.props.dispatch(
      fetchStatsLeaguesModes(end, response =>
        this.setState({data: response.leaguesModesBreakdown.countries}),
      ),
    );
  }

  toggleLang(value) {
    const {lang} = this.state;

    if (lang === value) {
      this.setState({lang: 'ALL'});
    } else {
      this.setState({lang: value});
    }
  }

  static renderRow(name, count, type) {
    const percent = (type[name] / count) * 100;

    return (
      <tr key={`${name}`}>
        <td style={{width: '150px '}}>Ligue de {name}</td>
        <th>{numeral(count).format('0,0')}</th>
        <th>{numeral(type[name]).format('0,0')}</th>
        <td className="text-center">{numeral(percent).format('0')} %</td>
      </tr>
    );
  }

  static orderTable(table) {
    // No order for this widget
    return table;
  }

  renderTable(table) {
    if (!table) return false;

    return (
      <div className="mt-3 table-responsive">
        <table className="table table-striped">
          <thead>
            <tr className="bg-gray">
              <th>Divisons</th>
              <th>Nombre</th>
            </tr>
          </thead>
          <tbody>
            {map(table.modes, (value, mode) => {
              return (
                <tr>
                  <td>{leagueMode[mode]}</td>
                  <td>
                    <b>{value}</b>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  }

  renderLeaguesByMode() {
    const {lang, data} = this.state;
    const table = data && data[lang];

    return table && <div className="mb-4">{this.renderTable(table)}</div>;
  }

  render() {
    const {end, lang} = this.state;

    return (
      <div id="divisionsByMode-stats-widget">
        <div className="box">
          <div className="box-header with-border">
            <h3 className="box-title pull-left">
              <i className="fa fa-users" /> Expert cette saison (en status live
              ou terminée)
            </h3>
          </div>
          <div className="box-body">
            <div className="text-center">
              <div className="inline lang">
                <button
                  className={classNames('btn btn-box-tool', {
                    selected: lang === 'FR',
                  })}
                  onClick={() => this.toggleLang('FR')}>
                  <span className="flag-icon flag-icon-fr" />
                </button>
                <button
                  className={classNames('btn btn-box-tool', {
                    selected: lang === 'GB',
                  })}
                  onClick={() => this.toggleLang('GB')}>
                  <span className="flag-icon flag-icon-gb" />
                </button>
                <button
                  className={classNames('btn btn-box-tool', {
                    selected: lang === 'ES',
                  })}
                  onClick={() => this.toggleLang('ES')}>
                  <span className="flag-icon flag-icon-es" />
                </button>
                <button
                  className={classNames('btn btn-box-tool', {
                    selected: lang === 'OTHER',
                  })}
                  onClick={() => this.toggleLang('OTHER')}>
                  <img
                    src={earthFlag}
                    alt="Drapeau de la terre"
                    className="flag-img-btn"
                  />
                </button>
              </div>
              <div className="inline data-range-picker">
                <SingleDatePickerWrapper
                  initialDate={moment(end)}
                  onDateChange={date => {
                    this.setState({
                      end: moment(date).format('YYYY-MM-DD'),
                    });
                  }}
                  isOutsideRange={() => false}
                />

                <button
                  className="ml-2 inline btn btn-default"
                  onClick={() => this.fetchStats()}>
                  <i className="fa fa-refresh" />
                </button>
              </div>
            </div>
          </div>
          {this.renderLeaguesByMode()}
        </div>
      </div>
    );
  }
}

DivisionsByMode.propsType = {
  currentSeason: PropTypes.string,
};

DivisionsByMode.defaultProps = {
  currentSeason,
};

export default connect(
  state => ({}),
  dispatch => ({dispatch}),
)(DivisionsByMode);



// WEBPACK FOOTER //
// ./src/pages/Monitoring/Statistics/Widgets/DivisionsByMode/index.js